import "./svg/sausage.svg"

export default {
    name: "sausage",
    viewBox: "103 103",
}
